module.exports = __webpack_public_path__ + "img/lr-cb66-y1.8fb2ab18.gif";